var kind = require("enyo/kind");

require("enyo-ui");

/**
 * [HyperLinkSupport]{@link enyo-ui.HyperLinkSupport} sets the default
 * properties and attributes for a hyperlink component and blocks DOM click
 * events, leaving tap events as one single unified method of interacting with
 * the link.
 *
 * @mixin enyo-ui.HyperLinkSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "enyo-ui.HyperLinkSupport",

    /**
     * Ensure the control renders as an anchor tag.
     *
     * @memberof enyo-ui.HyperLinkSupport
     * @private
     */
    tag: "a",

    /**
     * IE11 assumes all hyperlinks are draggable by default. This causes
     * problems with enyo's scrollers so we disable draggable by default. If you
     * do need draggable functionality, you should enable it explicitly and be
     * careful to test thoroughly on IE11.
     *
     * @memberof enyo-ui.HyperLinkSupport
     * @private
     */
    attributes: {
        draggable: "false"
    },

    /**
     * @private
     */
    handlers: {
        onmousedown: "onMouseDown"
    },

    /**
     * Ensure the necessary attributes are applied.
     *
     * @memberof enyo-ui.HyperLinkSupport
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.hrefChanged();
            this.targetChanged();
            this.relChanged();
        };
    }),

    /**
     * Syncs href attribute with [href]{@link enyo-ui.HyperLinkSupport#href}
     * property.
     *
     * @memberof enyo-ui.HyperLinkSupport
     * @method
     * @private
     */
    hrefChanged: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.setAttribute("href", this.get("href") || null);
        };
    }),

    /**
     * Syncs target attribute with [target]{@link
     * enyo-ui.HyperLinkSupport#target} property.
     *
     * @memberof enyo-ui.HyperLinkSupport
     * @method
     * @private
     */
    targetChanged: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.setAttribute("target", this.get("target") || null);
        };
    }),

    /**
     * Syncs rel attribute with [rel]{@link enyo-ui.HyperLinkSupport#rel}
     * property.
     *
     * @memberof enyo-ui.HyperLinkSupport
     * @method
     * @private
     */
    relChanged: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.setAttribute("rel", this.get("rel") || null);
        };
    }),

    /**
     * By default, we prevent hyperlinks from responding to click events.
     * Navigation should instead be handled by tap event.
     *
     * @memberof enyo-ui.HyperLinkSupport
     * @method
     * @private
     */
    previewDomEvent: kind.inherit(function(sup) {
        return function(event) {
            sup.apply(this, arguments);

            if (event.type === "click") {
                event.preventDefault();
            }
        };
    }),

    /**
     * Prevent default behavior on mousedown, this prevents firefox from
     * dragging links.
     *
     * @param  {Control}  sender  The sender of the event
     * @param  {Object}   event   The event object
     * @public
     */
    onMouseDown: kind.inherit(function(sup) {
        return function(sender, event) {
            if (this.getAttribute("draggable") === "false") {
                event.preventDefault();
            }
            sup.apply(this, arguments);
        };
    })

};
